var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCertificate = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 62,
  viewBox: "0 0 50 62",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 48,
  height: 60,
  rx: 5,
  stroke: "currentColor",
  strokeWidth: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 16,
  width: 22,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 22,
  width: 16,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 10,
  width: 30,
  height: 2,
  rx: 1,
  fill: "currentColor"
})));
export { SvgCertificate as ReactComponent };